<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import SalesRepModal from "@retailer/svelte/Settings/DistributorContacts/SalesRepModal.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import CurrentRetailerStore from "@retailer/svelte/stores/CurrentRetailerStore";
  import type { RetailerSalesRepContact, SalesRep } from "@shared/types/SalesRep";

  interface Message {
    id: number;
  }

  interface Conversation {
    ids: number[];
    sales_reps: SalesRep[];
    last_message: null | Message;
  }

  export let conversation: Conversation;
  export let callbacks: { [key: string]: CallableFunction };
  export let isAooEnabled: boolean = false;

  let newMessageValue = "";
  $: salesRep = conversation.sales_reps[0];
  let showSalesRepModal = false;
  let loadingSalesRepContact = false;
  let hideEmailButton = $CurrentRetailerStore?.aoo_streamlined_flow;

  function sendMessage() {
    if (!newMessageValue) {
      return;
    }
    if (conversation.last_message == null) {
      callbacks.message({
        distributor_id: conversation.sales_reps[0].distributor_id,
        sales_rep_id: conversation.sales_reps[0].id,
        message: newMessageValue,
      });
    } else {
      callbacks.respond({
        distributor_id: conversation.sales_reps[0].distributor_id,
        sales_rep_id: conversation.sales_reps[0].id,
        previous_message_id: conversation.last_message.id,
        message: newMessageValue,
      });
    }
    newMessageValue = "";
  }

  function handleEnterKey(event): void {
    if (event.key == "Enter") {
      sendMessage();
    }
  }

  const editSalesRepSuccessCB = (updatedSalesRep: RetailerSalesRepContact): void => {
    const { full_name, contact_email, contact_phone } = updatedSalesRep;
    salesRep = { ...salesRep, name: full_name, contact_email, contact_phone };
  };

  const disableButtonCheck = (newMessageValue, salesRep): boolean => {
    return !newMessageValue || !salesRep.contact_email || salesRep.deleted_at || isAooEnabled;
  };

  let handleAddEmailClick = async (): Promise<void> => {
    loadingSalesRepContact = true;

    try {
      const retailer_sales_rep_contact = await HttpPromise({
        method: "GET",
        url: `/api/retailer/sales_reps/${salesRep.id}/retailer_sales_rep_contact`,
      });
      salesRep = { ...salesRep, retailer_sales_rep_contact };
    } catch (err) {
      console.log(err);
    }

    showSalesRepModal = true;
    loadingSalesRepContact = false;
  };

  $: messagingDisabled = disableButtonCheck(newMessageValue, salesRep);
</script>

<svelte:window on:keydown={handleEnterKey} />
<div class="fizz-flow-12" style="padding: 20px 0">
  {#if !salesRep.deleted_at && !salesRep.contact_email}
    <div class="fizz-alert-warning fizz-alert--small">
      <p class="fizz-text-small" style="width: 80%;">
        Provi Chat messages are now sent to your sales rep via email. Please add {salesRep.name}'s
        email to continue messaging them.
      </p>
      <div class="fizz--alert-links">
        <button
          class="fizz-button fizz-button-small"
          class:fizz-button-spinner={loadingSalesRepContact}
          disabled={loadingSalesRepContact}
          on:click|preventDefault={handleAddEmailClick}
        >
          <span>Add email</span>
        </button>
      </div>
    </div>
  {:else if !salesRep.deleted_at && isAooEnabled}
    <div class="fizz-alert-error fizz-alert--small" data-testid="aoo-enabled-alert">
      <p class="fizz-text-small">
        <strong>Warning:</strong>Messages to this distributor
        <strong>must be sent</strong>through your email.
      </p>
      {#if !hideEmailButton}
        <div class="fizz--alert-links">
          <a
            href="mailto:{salesRep.contact_email}"
            class="fizz-button fizz-button-small fizz-button-icon"
          >
            <Icon type="MessageArrow" />
            <span>Send as email</span>
          </a>
        </div>
      {/if}
    </div>
  {/if}
  <div class="fizz-flex-row-8">
    <input
      id="send-message-{conversation.ids[0]}"
      bind:value={newMessageValue}
      disabled={isAooEnabled}
      class="fizz-input-text fizz-full-width"
      type="text"
      placeholder="Enter your message"
    />
    <button
      class="fizz-button fizz-button-secondary"
      disabled={messagingDisabled}
      id="send-message"
      on:click={sendMessage}
    >
      Send
    </button>
  </div>
</div>
<SalesRepModal {salesRep} bind:show={showSalesRepModal} successCallback={editSalesRepSuccessCB} />
